export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["तकनीकी सहायता अनुरोध"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["से"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["चैट"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["संदेश जोड़ें"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["फाइलें"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["आप एक या अधिक फाइलें अपलोड कर सकते हैं। फाइल का अधिकतम आकार - 10MB."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["संदेश का पाठ"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["भेजें"])}
}